<template>
  <p
    v-for="addressLine in formattedAddress"
    :key="addressLine"
    class="text-static-default-low"
  >
    {{ addressLine }}
  </p>
  <p class="text-static-default-low">{{ address.phone }}</p>
</template>

<script setup lang="ts">
import type { Address } from '@backmarket/nuxt-module-address/address'
import { useFormatAddress } from '@backmarket/nuxt-module-address/useFormatAddress'

const props = defineProps<{
  address: Address
}>()
const formattedAddress = useFormatAddress(
  {
    city: props.address.city,
    country: props.address.country,
    countryDialInCode: props.address.countryDialInCode,
    firstName: props.address.firstName || '',
    firstNamePronunciation: props.address.firstNamePronunciation || undefined,
    lastName: props.address.lastName || '',
    lastNamePronunciation: props.address.lastNamePronunciation || undefined,
    phone: props.address.phone,
    postalCode: props.address.postalCode || '',
    stateOrProvince: props.address.stateOrProvince || '',
    street: props.address.street,
    street2: props.address.street2 || undefined,
  },
  { includeName: true },
)
</script>
